import './ReportPreviewTable.scss';

import { bem } from 'mission-control-common-components';
import type { RefObject } from 'react';
import { useMemo } from 'react';

import type { LineItemMetrics } from '../../../../../../../apis/graphql';
import { EMPTY_REPORT_PREVIEW_TABLE_PLACEHOLDER_TEXT } from '../../../constants';
import { getReportPreviewColumns } from './getReportPreviewColumns';

const [block, element] = bem('report-preview-table');

type Props = {
  windowsCount: number;
  lineItemList: LineItemMetrics[];
  loadMoreTriggerRef: RefObject<HTMLTableRowElement>;
};

const ReportPreviewTable = ({ lineItemList, windowsCount, loadMoreTriggerRef }: Props): React.JSX.Element => {
  const columns = useMemo(() => getReportPreviewColumns(windowsCount), [windowsCount]);

  if (!lineItemList.length)
    return (
      <div className={element('empty-table-placeholder')} data-testid="empty-table-placeholder">
        {EMPTY_REPORT_PREVIEW_TABLE_PLACEHOLDER_TEXT}
      </div>
    );

  return (
    <table className={block()}>
      <thead>
        <tr>
          {columns.map(({ id, Header }) => (
            <th key={id}>{Header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {lineItemList.map((lineItem) => (
          <tr key={lineItem.id}>
            {columns.map(({ id, accessor }) => (
              <td key={id}>{accessor(lineItem)}</td>
            ))}
          </tr>
        ))}
        <tr ref={loadMoreTriggerRef} />
      </tbody>
    </table>
  );
};

export default ReportPreviewTable;
